import type { InvoiceItemDto } from '../../../apis/hey-api/types.gen'
import type { InvoiceItem } from '../types/invoice'

// IO boundary: strip response-only fields (`amountCents`, `fromAddon`) so that
// PATCH / POST bodies match the backend request contract.
export function toInvoiceItemDto(item: InvoiceItem): InvoiceItemDto {
  return {
    productKey: item.productKey,
    productName: item.productName,
    qty: item.qty,
    rateCents: item.rateCents,
    discountPercent: item.discountPercent,
    isOTP: item.isOTP,
    sub: item.sub,
    term: item.term,
  }
}
